import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AppProvider } from './lib/app-context';
import { RootShell, UserShell, AdminShell, GuardedAdmin } from './components/Shells';
import { MemberHome, OrdersPage, PlansPage, ProfilePage } from './pages/MemberPages';
import { AdminDashboard } from './pages/admin/AdminDashboard';
import { AdminMembers } from './pages/admin/AdminMembers';
import { AdminPlans } from './pages/admin/AdminPlans';
import { AdminAutomation } from './pages/admin/AdminAutomation';
import { AdminNotifications } from './pages/admin/AdminNotifications';
import { AdminSettings } from './pages/admin/AdminSettings';
import { AdminSecurity } from './pages/admin/AdminSecurity';
import { AdminAudit } from './pages/admin/AdminAudit';
import { AdminAppearance } from './pages/admin/AdminAppearance';
import { BankPage } from './pages/BankPage';
import { AdminBank } from './pages/admin/AdminBank';
import './styles/app.css';
import './styles/social.css';
import './styles/appearance.css';
import './styles/usability.css';
import './styles/bank.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <AppProvider>
        <Routes>
          <Route element={<RootShell />}>
            <Route path="bank" element={<BankPage />} />
            <Route element={<UserShell />}>
              <Route index element={<MemberHome />} />
              <Route path="plans" element={<PlansPage />} />
              <Route path="orders" element={<OrdersPage />} />
              <Route path="profile" element={<ProfilePage />} />
            </Route>
            <Route path="admin" element={<GuardedAdmin />}>
              <Route element={<AdminShell />}>
                <Route index element={<AdminDashboard />} />
                <Route path="members" element={<AdminMembers />} />
                <Route path="plans" element={<AdminPlans />} />
                <Route path="bank" element={<AdminBank />} />
                <Route path="automation" element={<AdminAutomation />} />
                <Route path="notifications" element={<AdminNotifications />} />
                <Route path="settings" element={<AdminSettings />} />
                <Route path="appearance" element={<AdminAppearance />} />
                <Route path="security" element={<AdminSecurity />} />
                <Route path="audit" element={<AdminAudit />} />
              </Route>
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </AppProvider>
    </BrowserRouter>
  </React.StrictMode>
);
